import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { key: 1 }
const _hoisted_2 = { class: "padding-4 bg-primary-50 margin-b-4 rounded-lg" }
const _hoisted_3 = { class: "flex justify-between" }
const _hoisted_4 = { class: "flex items-center gap-3" }
const _hoisted_5 = { class: "grid grid-cols-2 gap-3 my-3" }
const _hoisted_6 = {
  key: 0,
  class: "grid grid-cols-2 gap-3 my-3"
}

import { computed, ref, onMounted } from 'vue'
import {
  UIDrawer,
  UIDrawerContent,
  UISelect,
  UIEmpty,
  UIDivider,
  UITag,
  UICollapse,
  UICollapseItem,
  UITextSmMedium,
  UITextSmRegular,
  UIAvatar,
  UIButton,
} from '@gohighlevel/ghl-ui'
import {
  UserCircleIcon,
  EyeIcon,
  LinkExternal02Icon,
} from '@gohighlevel/ghl-icons/24/outline'
import { startCase, debounce, uniqBy } from 'lodash'
import { getProfileColor, getInitials, getEmailDate } from 'common/utils/helper'
import { contactInfoKeys } from 'common/utils/const_helper'


export default /*#__PURE__*/_defineComponent({
  __name: 'ContactPanel',
  props: {
  show: {
    type: Boolean,
    default: false,
  },
  service: {
    type: Object,
  },
  state: {
    type: Object,
  },
  locationId: {
    type: String,
  },
  to: {
    type: String,
    default: 'body'
  }
},
  emits: ['update:close', 'update:select'],
  setup(__props, { emit }) {

const props = __props;




// contact variables
const selectedContact = ref('')
const contacts: any = ref([])
const loading = ref(false)
const totalContacts = ref(0)
const searchText = ref('')
const page = ref(0)
const initialList = ref([])
// select contact details
const selectedContactDetails = ref({})

// contact info
const contactInfo = computed(() => {
  if (selectedContactDetails.value) {
    const data = Object.entries(selectedContactDetails.value).filter(
      ([key, val]) => contactInfoKeys.includes(key)
    )
    return Object.fromEntries(data)
  }
  return {}
})

// custom fields
const customFields = computed(() => {
  return selectedContactDetails.value?.custom_fields?.map((item: any) => {
    const key = props.state?.customFieldsLocation?.filter(
      (el: any) => el?.id === item.id
    )[0]?.name
    return {
      key,
      value:
        item['field_value_string'] ??
        item['field_value_number'] ??
        item['field_value_array']?.join(', '),
    }
  })
})

const handleClose = async (val: any) => {
  if (!searchText.value) return
  if (!val) {
    // initialize contacts list after close (if search happened)
    setTimeout(() => {
      searchText.value = ''
      // include current selection
      const curSelection = {
        label: selectedContactDetails.value?.contact_name,
        value: selectedContact.value,
      }
      contacts.value = uniqBy([curSelection, ...initialList.value], 'value')
    }, 500)
  }
}

const fetchContacts = async (query: string = '', loadMore: boolean = false) => {
  try {
    loading.value = true
    const { data } = await props?.service.contactSearch({
      locationId: props.locationId,
      query,
      tag: '',
      assignedTo: props.state.enableAssignToData
        ? props.state.userId ?? ''
        : '',
      page: page.value / 20 + 1,
    })
    const { hits, total } = data.hits

    const newList = hits.map((item: any) => ({
      label: startCase(item?._source?.contact_name),
      value: item?._id,
      data: item?._source,
    }))

    if (loadMore) contacts.value = [...contacts.value, ...newList]
    else contacts.value = newList
    loading.value = false
    if (total.value > totalContacts.value) totalContacts.value = total.value
  } catch (error) {
    console.log(error)
    loading.value = false
  }
}

const handleSearch = debounce(async (val: string) => {
  searchText.value = val
  page.value = 0
  await fetchContacts(val)
}, 500)

const handleScroll = async (e: any) => {
  if (contacts.value.length >= totalContacts.value) return
  const currentTarget = e.currentTarget as HTMLElement
  if (
    totalContacts.value > 0 &&
    currentTarget.scrollTop + currentTarget.offsetHeight >=
      currentTarget.scrollHeight - 10
  ) {
    page.value = page.value + 1
    await fetchContacts(searchText.value, true)
  }
}

const handleSelect = (val: string) => {
  selectedContact.value = val
  updateSelectedDetails()
  emit('update:select', selectedContactDetails.value)
}

const handleRedirect = () => {
  const url = `${
    props.state.parentBaseUrl ?? window?.location?.ancestorOrigins[0]
  }/location/${props.locationId}/customers/detail/${selectedContact.value}`
  window.open(url, '_blank')
}

const updateSelectedDetails = () => {
  let data = contacts?.value?.filter(
    (val: any) => val.value === selectedContact.value
  )[0]?.data

  // these values are capitalized on sent email from contacts side
  const capitalizedKeys = [
    'contact_name',
    'full_name',
    'first_name',
    'last_name',
    'company_name',
    'city',
  ]

  for (const el in data) {
    // convert number to email format
    if (el === 'date_of_birth')
      data[el] = data[el] ? getEmailDate(data[el]) : ''
    if (capitalizedKeys.includes(el)) data[el] = startCase(data[el])
  }

  selectedContactDetails.value = data
}

onMounted(async () => {
  await fetchContacts()
  initialList.value = contacts.value
  handleSelect(contacts.value[0]?.value)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(UIDrawer), {
    id: "pg-email-builder-preview__contact-preview-drawer",
    show: __props.show,
    "onUpdate:show": _cache[0] || (_cache[0] = ($event: any) => (emit('update:close'))),
    width: 512,
    to: __props.to
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(UIDrawerContent), {
        id: "pg-email-builder-preview__contact-preview-drawer-content",
        title: "Preview contact info",
        class: "p-0 fonts-fallback"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(UISelect), {
            type: "avatar",
            placeholder: _ctx.$t('common.searchForAContact'),
            options: contacts.value,
            value: selectedContact.value,
            loading: loading.value,
            searchText: searchText.value,
            "reset-menu-on-options-change": false,
            onSearch: _unref(handleSearch),
            "onUpdate:value": handleSelect,
            "onUpdate:show": handleClose,
            onScroll: handleScroll,
            filterable: "",
            remote: "",
            class: "mb-4",
            id: "pg-email-builder-preview__select_contact"
          }, null, 8 /* PROPS */, ["placeholder", "options", "value", "loading", "searchText", "onSearch"]),
          _createVNode(_unref(UIDivider)),
          (!selectedContact.value)
            ? (_openBlock(), _createBlock(_unref(UIEmpty), {
                key: 0,
                id: "pg-email-builder-preview__empty_contact",
                title: _ctx.$t('common.noContactsPickedYet'),
                description: _ctx.$t('common.emptyContactDescription'),
                icon: _unref(UserCircleIcon)
              }, null, 8 /* PROPS */, ["title", "description", "icon"]))
            : (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(_unref(UITag), {
                    class: "gap-2 margin-b-4",
                    type: "info"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(EyeIcon), { class: "w-5 h-5 mr-1 inline" }),
                      _createTextVNode(_toDisplayString(_ctx.$t('common.previewingAs')), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                  }),
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                      _createVNode(_unref(UIAvatar), {
                        style: _normalizeStyle({
                  backgroundColor: _unref(getProfileColor)(_unref(contactInfo)?.contact_name),
                })
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(getInitials)(_unref(contactInfo)?.contact_name)), 1 /* TEXT */)
                        ]),
                        _: 1 /* STABLE */
                      }, 8 /* PROPS */, ["style"]),
                      _createVNode(_unref(UITextSmMedium), null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(contactInfo)?.contact_name), 1 /* TEXT */)
                        ]),
                        _: 1 /* STABLE */
                      })
                    ]),
                    _createVNode(_unref(UIButton), {
                      onClick: handleRedirect,
                      text: ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(LinkExternal02Icon), { class: "text-primary-700 w-4 h-5 cursor-pointer" })
                      ]),
                      _: 1 /* STABLE */
                    })
                  ])
                ]),
                _createVNode(_unref(UICollapse), { defaultExpandedNames: "contact-info" }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(UICollapseItem), {
                      name: "contact-info",
                      title: _ctx.$t('common.contactInfo')
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(_unref(contactInfo) ?? {}), (item) => {
                          return (_openBlock(), _createElementBlock("div", null, [
                            _createElementVNode("div", _hoisted_5, [
                              _createVNode(_unref(UITextSmMedium), null, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_unref(startCase)(item.split('_').join(' '))) + ":", 1 /* TEXT */)
                                ]),
                                _: 2 /* DYNAMIC */
                              }, 1024 /* DYNAMIC_SLOTS */),
                              _createVNode(_unref(UITextSmRegular), null, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_unref(contactInfo)[item] ?? ''), 1 /* TEXT */)
                                ]),
                                _: 2 /* DYNAMIC */
                              }, 1024 /* DYNAMIC_SLOTS */)
                            ])
                          ]))
                        }), 256 /* UNKEYED_FRAGMENT */))
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["title"]),
                    (_unref(customFields)?.length)
                      ? (_openBlock(), _createBlock(_unref(UICollapseItem), {
                          key: 0,
                          name: "custom-fields",
                          title: _ctx.$t('common.customFields')
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(customFields), ({ key, value }) => {
                              return (_openBlock(), _createElementBlock("div", null, [
                                key
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                      _createVNode(_unref(UITextSmMedium), null, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_unref(startCase)(key)) + ":", 1 /* TEXT */)
                                        ]),
                                        _: 2 /* DYNAMIC */
                                      }, 1024 /* DYNAMIC_SLOTS */),
                                      _createVNode(_unref(UITextSmRegular), null, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(value), 1 /* TEXT */)
                                        ]),
                                        _: 2 /* DYNAMIC */
                                      }, 1024 /* DYNAMIC_SLOTS */)
                                    ]))
                                  : _createCommentVNode("v-if", true)
                              ]))
                            }), 256 /* UNKEYED_FRAGMENT */))
                          ]),
                          _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["title"]))
                      : _createCommentVNode("v-if", true)
                  ]),
                  _: 1 /* STABLE */
                })
              ]))
        ]),
        _: 1 /* STABLE */
      })
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["show", "to"]))
}
}

})